import React from 'react';
import { CheckBoxField, Container, FormPanel } from '@sencha/ext-modern';

export default function GroupCheckBox(props) {
	const { label, options, onCheck, checked, margin } = props
	return (
		<FormPanel margin={margin} layout={{ type: "vbox", wrap: "true" }} padding={0} bodyStyle={{ backgroundColor: "#ffffff" }}>
			<Container layout={{ type: "hbox", wrap: "true" }} style={{ fontSize: "12px" }}>
				{label && <p>{label}</p>}
				{options && options.map((o, index) => {
					return (<CheckBoxField boxLabel={o} key={index} onCheck={onCheck} onUnCheck={onCheck} value={label} checked={checked && checked.includes(o)} padding={label && '0 0 0 15' || '0 15 0 0'} />)
				})}
			</Container>
		</FormPanel>
	)
}